import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CurrentCustomerBillTosModel, getCurrentCustomerBillTos } from "@ucs/Services/GetCurrentCustomerBillTosService";
import { ApiHandlerNoApiParameter, ApiHandlerNoParameter, CustomHandler } from "@ucs/Store/CustomHandlerCreator";

type CustomHandlerType = ApiHandlerNoParameter<any, CurrentCustomerBillTosModel>;

export const DispatchBeginLoadCurrentCustomerBillTos: CustomHandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadCurrentCustomerBillTos",
    });
};

export const RequestDataFromApi: CustomHandlerType = async props => {
    const response = await getCurrentCustomerBillTos();
    props.apiResult = response;
};

export const DispatchCompleteLoadCurrentCustomerBillTos: CustomHandlerType = props => {
    props.dispatch({
        type: "Custom/CompleteLoadCurrentCustomerBillTos",
        collection: props.apiResult,
    });
};

export const chain = [DispatchBeginLoadCurrentCustomerBillTos, RequestDataFromApi, DispatchCompleteLoadCurrentCustomerBillTos];

const loadCurrentCustomerBillTos = createHandlerChainRunner(chain, "LoadCurrentCustomerBillTos");
export default loadCurrentCustomerBillTos;